<script>
  import { cart, stage, Stages, loadCart } from './storage.js';
  import Modal from './Modal.svelte';
  import Delivery from './Delivery.svelte';

  let showModal = false;
  let modalMessage;

  const checkNextStep = () => {
    if (!$cart.all_digital && !$cart.delivery_method_id) {
      modalMessage = 'Wybierz metodę dostawy.';
      showModal = true;
      return;
    }

    $stage = Stages.FORM;
  }

  const onDelivery = () => {
    showModal = false;
    loadCart();
  }
</script>


<div class="actions">
  {#if $cart && $cart.order_items.length}
    <div class="button" on:click={checkNextStep}>Zamów teraz</div>
  {/if}
</div>


{#if showModal}
  <Modal on:click={() => showModal = false}>
    {modalMessage}
    <Delivery on:refresh={onDelivery} />
  </Modal>
{/if}


<style>
  .actions {
    margin-bottom: 15px;
    display: flex;
    justify-content: flex-end;
  }
</style>
